<template>
  <node-view-wrapper class="editor-wrapper-std" contenteditable="false">
    <div class="label">Галерея</div>
    <div class="close" @click="removeNode"><v-icon>mdi-close</v-icon></div>
    <node-view-content class="content-dom d-flex flex-wrap" />
    <div class="editor-wrapper-std__controls">
      <v-btn depressed outlined class="mr-4" @click="addImages"
        >Добавить загруженные</v-btn
      >
      <uploader-button
        btn-title="Загрузить новые"
        :work-dir="workDir"
        multiple
        @upload-success="onUploadSuccess"
        @upload-error="onUploadError"
      />
    </div>
    <file-manager-dialog
      v-model="fmDialog"
      selected-path=""
      src="texteditor"
      :work-dir="workDir"
      :allowed-extensions="['jpg', 'jpeg', 'png', 'svg', 'gif']"
      multiple
      @fm-select="fmSelect"
      @fm-close="fmClose"
    />
  </node-view-wrapper>
</template>

<script>
import { nodeViewProps, NodeViewWrapper, NodeViewContent } from "@tiptap/vue-2";
import FileManagerDialog from "../../FileManagerDialog/FileManagerDialog.vue";
import UploaderButton from "@/components/UploaderButton.vue";

export default {
  components: {
    NodeViewWrapper,
    NodeViewContent,
    FileManagerDialog,
    UploaderButton
  },
  props: nodeViewProps,
  data() {
    return {
      fmDialog: false
    };
  },
  computed: {
    storagePrefix() {
      return this.$store.getters.getStoragePrefix;
    },
    workDir() {
      return this.editor?.imagesUploadDir || "/images";
    }
  },
  methods: {
    addImages() {
      this.fmDialog = true;
    },
    fmClose() {
      this.fmDialog = false;
    },
    fmSelect(files) {
      this.fmDialog = false;
      this.addFilesToGallery(files);
    },
    removeNode() {
      this.deleteNode();
    },
    addFilesToGallery(files) {
      files.forEach(file => {
        let src = file;
        if (!src.startsWith("/")) src = `/${src}`;
        src = `${this.storagePrefix}${src}`;

        const endPos = this.getPos() + this.node.nodeSize - 1;
        this.editor.commands.focus("start");
        this.editor
          .chain()
          .insertContentAt(endPos, {
            type: "imagegalleryitem",
            attrs: {
              src
            }
          })
          .focus(endPos)
          .run();
      });
    },
    onUploadSuccess(files) {
      this.addFilesToGallery(files);
    },
    onUploadError(error) {
      this.$store.commit("addNotice", {
        type: "error",
        message: error
      });
    }
  }
};
</script>
